import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, inject, isDevMode } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { loaderInterceptor } from '../Interceptors/loader-interceptor';
import { authInterceptor } from '../Interceptors/auth-interceptor';
import { authRetryInterceptor } from '../Interceptors/auth-retry-interceptor';
import { AuthBootstrapService } from '../Services/Authorization/auth-bootstrap.service';
import { PortalSessionDataService } from '../Shared/utilities';
import { provideAppInitializer } from '@angular/core';

// Location strategy
import { LocationStrategy } from '@angular/common';
import { HashBangLocationStrategy } from '../Shared/hashbang-location-strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),   // NO withHashLocation() — we handle it manually
    provideHttpClient(
      // Order matters:
      //   loader   — outermost, ref-counts the whole user-visible operation
      //              (including retries) as a single show/hide pair.
      //   auth     — adds Authorization: Bearer header on the way out.
      //   retry    — innermost, catches 401/5xx and replays with a fresh JWT.
      withInterceptors([loaderInterceptor, authInterceptor, authRetryInterceptor])
    ),
    provideAppInitializer(() => {
      const bootstrap = inject(AuthBootstrapService);
      return bootstrap.ensureToken();
    }),
    PortalSessionDataService,

    // 👇 Register custom hashbang strategy
    { provide: LocationStrategy, useClass: HashBangLocationStrategy },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};
